import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { AdminComponent } from './features/admin/admin.component';
import { DiligenceComponent } from './features/diligence/diligence.component';
import { TosComponent } from './features/tos/tos.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { RoleGuard } from './shared/guards/admin.guard';
import { NotVerifiedComponent } from './features/not-verified/not-verified.component';
import { AccountsComponent } from './features/accounts/accounts.component';
import { OrganizationDetailsComponent } from './features/organizations/organization-details/organization-details.component';
import { NotFoundComponent } from './features/not-found/not-found.component';
import { AccountComponent } from './features/account/account.component';
import { ReportsComponent } from './features/reports/reports.component';
import { SignupRedirectComponent } from './features/signup/signup-redirect.component';
import { PricingSubscriptionComponent } from './features/pricing-subscription/pricing-subscription.component';
import { SubscriptionEntitlementGuard } from './shared/guards/subscription-entitlement.guard';
import { AuthErrorComponent } from './features/auth-error/auth-error.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'account',
    component: AccountComponent,
    canActivate: [AuthGuard, SubscriptionEntitlementGuard]
  },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [AuthGuard, SubscriptionEntitlementGuard]
  },
  {
    path: 'accounts',
    component: AccountsComponent,
    canActivate: [RoleGuard],
    data: { allowedRoles: ['admin', 'sales'] }
  },
  {
    path: 'dueDiligence/:id',
    component: DiligenceComponent,
    canActivate: [AuthGuard, SubscriptionEntitlementGuard]
  },
  { path: 'tos', component: TosComponent },
  { path: 'notVerified', component: NotVerifiedComponent },
  { path: 'auth-error', component: AuthErrorComponent },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [RoleGuard],
    data: { allowedRoles: ['admin'], allowedPermissions: ['admin:everything'] }
  },
  {
    path: 'organizations/:id',
    component: OrganizationDetailsComponent,
    canActivate: [RoleGuard],
    data: { allowedRoles: [], allowedPermissions: ['read:organizations', 'admin:everything'] }
  },
  {
    path: 'signup',
    component: SignupRedirectComponent
  },
  {
    path: 'pricing-subscription',
    component: PricingSubscriptionComponent
  },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
